import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'

export default createUIDefinition({
    taskName: taskName.MAKE_CUSTOMER_SCAN_APPOINTMENT,
    widgetList: [
        {
            component: processUI.CREATE_3DSCAN_APPOINTMENT,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/check-in/make-customer-scan-appointment.js